<div>
    <div class="top-carousel" role="listbox">
    <div>
      <picture>
        <source
          srcset="/assets/images/img/contactusmobilebannerdesign.jpg"
          media="(max-width: 479px)"
        />
        <source
          srcset="/assets/images/img/contactusbanner.jpg"
          media="(max-width: 4000px)"
        />
        <source srcset="/assets/images/img/contactusbanner.jpg" />
        <img
          src="/assets/images/img/contactusbanner.jpg"
          alt="First slide"
          style="width: 100%"
        />
      </picture>
      <div class="mask rgba-black-light"></div>
    </div>
  </div>
</div>
<div class="container">
  <div class="concontainer">
    <h2>We would love to hear from you</h2>
    <h5>Fill up the form below and we will get back to you</h5>
  </div>
  <div class="conform">
    <div class="col-lg-6 col-md-12 col-sm-12">
      <div class="contact-details">
        <div class="contact-form">
          <form id="contact-form " method="post " action=" ">
            <div class="formControlSec">
              <div class="form-group congroup">
                <div class="name">
                  <input
                    type="text"
                    class="form-control box"
                    id="fname"
                    placeholder="First Name"
                    formControlName="firstName"
                    required
                  />
                </div>
                <div class="name">
                  <input
                    type="text"
                    class="form-control box"
                    id="lname"
                    placeholder="Last Name"
                    formControlName="lastName"
                    required
                  />
                </div>
                <div class="name">
                  <input
                    type="text"
                    class="form-control box"
                    id="mobno"
                    placeholder="Mobile Number"
                    formControlName="mobileNumber"
                    required
                  />
                </div>

                <div class="name">
                  <input
                    type="text"
                    class="form-control box"
                    id="fname"
                    placeholder="Your Email"
                    formControlName="firstName"
                    required
                  />
                </div>
                <div class="name">
                  <textarea
                    type="text"
                    style="height: 120px"
                    class="form-control box"
                    id="lname"
                    placeholder="Type Your Message"
                    formControlName="lastName"
                    required
                  ></textarea>
                </div>

                <div class="conbutton">
                  <button class="horse-bidcareer">
                    <a href="# ">SEND MESSAGE</a>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12 col-sm-12 mapcontainer">
      <div class="mapmain">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2445.6547901271797!2d-2.2123170342045992!3d52.19514732975404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870f05f0cc786e3%3A0xafbe5b61846a35ae!2sWorcester%20WR4%209GX%2C%20UK!5e0!3m2!1sen!2sin!4v1608749065065!5m2!1sen!2sin"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: 0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
        <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.0944683423686!2d-1.5126349841968203!3d52.404964079792535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48774bba9e26199d%3A0xb96a69d947997120!2s111%20New%20Union%20St%2C%20Coventry%20CV1%202NT%2C%20UK!5e0!3m2!1sen!2sin!4v1608257761420!5m2!1sen!2sin"
                    width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
        <!-- <img style="width: 87%;" src="../../../../../assets/images/1.jpg" alt=""> -->
        <!-- <img src="https://maps.googleapis.com/maps/api/staticmap?center=42.745330,-73.770960&zoom=12&size=400x400&key=AIzaSyBIwzALxUPNbatRBj3Xi1Uhp0fFzwWNBkE" alt=""> -->
      </div>
    </div>
  </div>
</div>
<div class="coniconcontainer">
  <div class="coniconmain">
    <div class="coniconfirst">
      <div class="coniconfirstmain">
        <img
          class="conimg"
          src="/assets/images/img/contact-location-icon.png"
          alt=""
        />
      </div>
      <h3 class="coniconheader">VISIT US</h3>
      <p class="coniconpara">We would love to receive you at</p>
      <p class="coniconcontent">
        Well care Ltd<br />
        County house<br />
        St Marys street<br />
        Worcester <br />
        WR1 1HB <br />
        12 D
      </p>
      <!-- <p class="coniconcontent">    WELL CARE LTD <br>
                12 D <br>
                SHRUB HILL INDUSTRIAL ESTATE <br>
                WORCESTER, WR4 9EL.</p> -->
    </div>
    <div class="coniconfirst">
      <div class="coniconfirstmain">
        <img
          class="conimg"
          src="/assets/images/img/contact-phone-icon.png"
          alt=""
        />
      </div>
      <h3 class="coniconheader">CALL US</h3>
      <p class="coniconpara">Feel free to connect us</p>
      <a class="coniconcontent" href="tel:+443337729507">0333 772 9507</a><br />

      <a class="coniconcontent" href="tel:+447510698999">07510698999</a>
      <!-- <a class="coniconcontent" href="tel:+447742426100">0774 242 6100</a> -->
    </div>
    <div class="coniconfirst">
      <div class="coniconfirstmain">
        <img
          class="conimg"
          src="/assets/images/img/contact-mail-icon.png"
          alt=""
        />
      </div>
      <h3 class="coniconheader">MESSAGE US</h3>
      <p class="coniconpara">Leave us a Message</p>
      <a class="coniconcontent" href="mailto:info@wellcareltd.co.uk"
        >info@wellcareltd.co.uk</a
      >
    </div>
  </div>
</div>
